/**
 * Reformation Footer JavaScript
 * Handles mobile accordion menus, back to top scrolling, and currency/language forms
 */
document.addEventListener('DOMContentLoaded', () => {
  // Mobile accordion toggle for footer menus
  const collapsibleTitles = document.querySelectorAll('.reformation-footer__widget-title.is-collapsible');
  collapsibleTitles.forEach((title) => {
    title.addEventListener('click', () => {
      const menu = title.nextElementSibling;
      if (menu && menu.classList.contains('reformation-footer__menu')) {
        const isOpen = title.classList.contains('is-open');
        if (isOpen) {
          title.classList.remove('is-open');
          menu.classList.remove('is-open');
          title.setAttribute('aria-expanded', 'false');
        } else {
          title.classList.add('is-open');
          menu.classList.add('is-open');
          title.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Back to top smooth scroll
  const backToTopBtn = document.querySelector('.reformation-footer__back-to-top');
  if (backToTopBtn) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 350) {
        backToTopBtn.classList.add('is-visible');
      } else {
        backToTopBtn.classList.remove('is-visible');
      }
    }, { passive: true });

    backToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // Handle currency / language selector change
  const locSelects = document.querySelectorAll('.reformation-footer__select');
  locSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });
});
